import React, {useState} from "react";

import Button from '../../../Form/Button/Button';
import {LoadingButton} from '../../../Form/Button/Button';
import withFeatureFlags from '../../../FeatureFlags/withFeatureFlags';
import TextInput from "../../../Form/TextInput/TextInput";
import ButtonGroup from "../../../Form/Button/ButtonGroup";
import ResendOtp from "../../../ResendOtp/ResendOtp";
import {useLogger} from "../../../../contexts/Logger";

/** @import {OtpStepProps} from "./OtpStepTypes" */
/** @import {WithFeatureFlagsProps} from "../../../FeatureFlags/FeatureFlagsTypes" */

import './withdrawal.scss';

function OtpStep(/** @type {OtpStepProps & WithFeatureFlagsProps} */ props) {
    const {
        onCancel,
        onConfirm,
        isNoticeWithdrawal,
        isLoading,
        error,
        verificationToken,
    } = props;

    const [otp, setOtp] = useState('');
    const [otpMode, setOtpMode] = useState('sms');
    const [isResendingOtp, setIsResendingOtp] = useState(false);
    const logger = useLogger();
    
    const onSubmitClicked = async (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();
        if (typeof onConfirm === 'function') await onConfirm(otp, otpMode, event);
        return false;
    };

    const onCancelClicked = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();
        if (typeof onCancel === 'function') onCancel(event);
        return false;
    };

    const onOtpInputChanged = (/** @type {string} */ otpValue) => {
        if (/[0-9]+/.test(otpValue) || otpValue === '') {
            setOtp(otpValue);
        }
    };

    const renderConfirmButton = () => {
        return isLoading ?
            <LoadingButton size='med' /> :
            <Button size='med' type="submit" label="Send" onClick={onSubmitClicked} disabled={(otp.length !== 5 && otp.length !== 6) || isLoading || isResendingOtp} />
    };

    const getOtpText = () => {
        if (!props.featureEnabled('voice_otp'))
            return "We've sent you a one-time password via text, please enter it here."
            
        return otpMode === 'sms'
            ? "Please enter the one-time password we texted you with."
            : "Please enter the one-time password we called you with.";        
    };
    
    return (
        <form className="withdrawal withdrawal--step-1">
            <div className="withdrawal__section">
                <h3 className="withdrawal__title">Withdraw</h3>
            </div>
            <div className="withdrawal__divider" />
            <div className="withdrawal__section">
                <div className="withdrawal__line withdrawal__line withdrawal__line withdrawal__line--wrap">{getOtpText()}</div>
            </div>
            <div className="withdrawal__divider" />
            <div className="withdrawal__section withdrawal__section--otp">
                <div className="withdrawal__section--horizontal withdrawal__space-below">
                    <TextInput
                        className="reference__input"
                        placeholder="One-time password"
                        value={otp}
                        onChange={onOtpInputChanged}
                        type="text"
                        maxLength={6}
                    />
                </div>

                {error && error.message && (<div className={"withdrawal__error withdrawal__error--show"}>{error.message}</div>)}

                <div className="withdrawal__section--horizontal-otp2">
                    <div className="withdraw__actions">
                        <ButtonGroup noGutter>
                            {renderConfirmButton()}
                            <Button variant='secondary' size='med' type="button" label="Cancel" onClick={onCancelClicked} disabled={isLoading} />
                        </ButtonGroup>
                    </div>
                </div>

                <ResendOtp
                    linkClassName="withdrawal__link withdrawal__resend-otp__link"
                    verificationToken={verificationToken}
                    isResendingCallback={setIsResendingOtp}
                    counterClassName="withdrawal__resend-otp__counter"
                    onModeChanged={setOtpMode}
                    analyticsRegion="dashboard"
                    analyticsAction="Withdrawal"
                    isNoticeWithdrawal={isNoticeWithdrawal}
                />
            </div>
        </form>
    );
}

export default withFeatureFlags(OtpStep);